// extracted by mini-css-extract-plugin
export default {"main":"menuleft_main__KP+Hj","menuitem":"menuleft_menuitem__kzb4O","menu":"menuleft_menu__1pgCS","menulist":"menuleft_menulist__+kC8M","icon":"menuleft_icon__R1eAD"};